<template>
  <div v-if="application && $store.state.App.states">
    <prequalification-form ref="prequal"
                           :program="application.program"
                           :google-api-key="$store.state.App.env.GOOGLE_API_KEY"
                           :states="$store.state.App.states"
                           :counties="$store.state.App.counties"
    ></prequalification-form>
    <div class="app-wizard-page" v-if="application.status.allow_household_edit">
      <div id="apply-area" class="">
        <div class="uk-grid" >
          <div class="uk-width-1-1">
            <div class="uk-vertical-align uk-text-center uk-cover-background uk-animation-fade uk-animation-5 " id="section-top-bg">
              <div class="uk-vertical-align-middle uk-width-9-10 uk-width-medium-2-3 uk-contrast">
                <p class="uk-visible-small">&nbsp;</p>
                <h1 class=" uk-margin-small-top" data-uk-scrollspy="{cls:'uk-animation-fade', delay:500}" >
                  <strong>{{ __('tenant.current_section', {program: application.program.program_name, step: currentStep}) }}</strong>
                  <span v-if="currentStepObject">{{ currentStepObject.title }}</span>
                </h1>
                <div class="uk-progress uk-progress-success uk-progress-striped uk-active">
                  <div class="uk-progress-bar" :style="{width: `${progressPercent}%`, backgroundColor: programSettings['primary-program-color']}"><span>{{ progressPercent }}%</span></div>
                </div>
                <p class="uk-text-small uk-align-center">{{ __('tenant.your_progress') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-container">
        <div class="uk-grid" id="section-nav">
          <div class="uk-width-1-1 uk-margin-small-bottom">
            <form-wizard
              @on-complete="onComplete"
              @on-change="onStepChange"
              @on-error="onStepError"
              title=""
              subtitle=""
              :color="programSettings['primary-program-color']"
            >
              <tab-content
                :title="step.title"
                v-for="(step, index) in steps"
                :key="index"
                :before-change="() => validateStep(index)"
                icon="uk-icon-dot-circle-o uk-icon-tiny"
              >
                <label v-if="index === 0" id="screen-reader-checkbox">
                  <input type="checkbox" :value="usingScreenReader" @change="onUsingScreenReaderChange" autofocus />
                  {{ __('global.using_screen_reader') }}
                </label>
                <h1 v-if="usingScreenReader" tabindex="0">step {{ index + 1 }}: {{ step.title }}</h1>
                <component
                  :is="step.component"
                  :ref="step.key"
                  @done="stepUpdated"
                  @loading="loadingState"
                  @setLastStep="setLastStep"
                />
              </tab-content>
              <div class="uk-text-danger uk-width-1-1 uk-text-right" v-if="showErrorMessage">Sorry, there seems to be some errors on your form. Please check your entries and try again.</div>
              <template slot="footer" slot-scope="props">
                <div class="wizard-footer-left">
                  <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab();" :style="props.fillButtonStyle" tabindex="0">{{ __('tenant.previous') }}</wizard-button>
                </div>
                <div class="wizard-footer-right">
                  <div>
                    <wizard-button v-if="!props.isLastStep" :disabled="loading" @click.native="props.nextTab();" :style="props.fillButtonStyle" class="wizard-footer-right uk-button " tabindex="0">{{ __('tenant.save_and_continue') }}</wizard-button>
                    <wizard-button v-else :disabled="loading" @click.native="onComplete" :style="props.fillButtonStyle" class="wizard-footer-right finish-button uk-button uk-button-primary" tabindex="0">{{props.isLastStep ? __('global.complete') : __('tenant.save_and_continue')}}</wizard-button>
                  </div>
                </div>
              </template>
            </form-wizard>
          </div>
        </div>
      </div>

      <modal-dialog :title="__('tenant.are_you_sure')"
                    :confirm-text="__('global.ok')"
                    :cancel-text="__('global.cancel')"
                    ref="confirmSubmitDialog"
                    @confirm="onCompleteModalConfirm">
        {{ __('tenant.submitting_note') }}
      </modal-dialog>

      <modal-dialog :title="__('jobs.application_student_submit_title')"
                    :confirm-text="__('global.ok')"
                    :cancel-text="__('global.cancel')"
                    ref="studentSubmitDialog"
                    @confirm="">
        {{ __('jobs.application_student_submit_confirmation') }}
      </modal-dialog>

    </div>
    <div v-else class="uk-container">
      <div class="uk-grid">
        <div class="uk-width-4-5 uk-align-center">
          <h1>This application is locked for editing.</h1>
          <h2>Status: {{ application.status.program_application_status_name }}</h2>
          <h3>{{ application.status.description }}</h3>
        </div>
      </div>
    </div>

    <vk-modal @cancel="onCloseErrorModal" stuck :show.sync="showErrorModal">
      <p class="uk-text-center">{{ __('tenant.please_correct_errors') }}</p>
      <div class="button-wraper uk-width-1-1">
        <button ref="btnCorrectError" class="uk-button uk-button-danger uk-width-1-2 uk-align-center uk-text-capitalize uk-margin-top" :aria-label="__('tenant.please_correct_errors')" @click="onCloseErrorModal"> {{ __('global.ok') }}</button>
      </div>
    </vk-modal>

    <vk-modal @cancel="onComeBackModal" stuck :show.sync="showComeBackModal">
      <p class="uk-text-center">{{ __('tenant.you_come_back') }}</p>
      <div class="button-wraper uk-width-1-1">
        <button ref="btnComeBack" class="uk-button uk-button-primary uk-width-1-2 uk-align-center uk-text-capitalize uk-margin-top" :aria-label="__('tenant.you_come_back')"  @click="onComeBackModal"> {{ __('global.ok') }}
        </button>
      </div>
    </vk-modal>
  </div>
</template>

<script>
  import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import ModalDialog from "../../components/Common/ModalDialog";
  import {mapActions, mapGetters, mapState} from "vuex";

  export default {
    name: "AppWizard",
    props: ['id'],
    components: {
      ModalDialog,
      FormWizard,
      TabContent,
      WizardButton,
    },
    data() {
      return {
        loading: false,
        showComeBackModal: false,
        showErrorModal: false,
        showErrorMessage: false,
        currentStep: 1,
        props: {
          title: '',
          subtitle: '',
        },
      }
    },
    mounted() {
      if (this.user)
      {
        this.loading = true;
        this.fetchApplication(this.id)
      }
    },
    watch: {
      user: {
        deep: true,
        handler(newVal, oldVal) {
          if (!oldVal && newVal)
          this.fetchApplication(this.id)
        }
      },
      loading: {
        handler: function(newValue, oldValue) {
          this.$isLoading(newValue)
        },
      },
      showErrorModal: function(newValue) {
        this.onShowModalChange(newValue);
      },
      showComeBackModal: function(newValue) {
        this.onShowModalChange(newValue);
      },
    },

    computed: {
      currentStepObject() {
        let currentStepKey = 'step'+this.currentStep;
        for(var i in this.steps) {
          if(this.steps[i].key == currentStepKey) {
            return this.steps[i];
          }
        }
      },
      user() {
        return this.$store.getters['App/user']
      },
      progressPercent() {
        return Math.ceil(100 / this.steps.length * (this.currentStep-1))
      },
      steps() {
        return this.$store.getters['Application/steps'](this.__)
      },
      ...mapState('App', {
        env: state => state.env,
        permissions: state => state.permissions,
        usingScreenReader: state => state.usingScreenReader,
      }),
      ...mapState('Application', {
        application: state => state.application,
        userIsStudent: state => state.userIsStudent,
      }),
      ...mapGetters('Application', [ 'programSettings' ])
    },

    methods: {
      ...mapActions('App', [ 'setUsingScreenReader' ]),
      onComeBackModal() {
        this.showComeBackModal = false
      },
      onCloseErrorModal() {
        this.showErrorModal = false
      },
      setLastStep(step) {
        if(step === 'current') {
          this.$store.commit('Application/setLastStep', this.currentStep);
        } else if(step !== null && step !== undefined) {
          this.$store.commit('Application/setLastStep', step);
        }else {
          this.$store.commit('Application/setLastStep', null);
        }
      },
      setLoading(val)
      {
        this.loading = val
      },
      fetchApplication(id)
      {
        this.$store
          .dispatch('Application/fetch', id)
          .then((res) => {
            this.loading = false
            if (this.application.program.slug === 'jobs')
            {
              if (
                (!this.application.prequal_answers || this.application.prequal_answers.length === 0) &&
                this.application.program.settings['requires-prequalification-questions']
              ) {
                this.$refs.prequal.showForApplication(this.application)
              }
            } else {
              if (
                (!this.application.prequal_answers || this.application.prequal_answers.length === 0) &&
                this.application.program.settings['requires-prequalification-questions']
              ) {
                this.$refs.prequal.showForApplication(this.application);
              } else if (this.application.unit_ledger_entries.length > 0) {
                this.showComeBackModal = true
              }
            }
          })
          .catch((error) => {
            this.loading = false
          })
        this.$store
          .dispatch('Application/fetchVendorList', id)
      },
      loadingState(loading) {
        this.loading = loading
      },
      async onComplete() {
        if(await this.validateStep(this.currentStep-1))
        {
          if(this.userIsStudent) {
            this.$refs.confirmSubmitDialog.open();
            // this.onCompleteStudent()
          }else {
            this.$refs.confirmSubmitDialog.open();
          }
        }
      },
      async onCompleteStudent() {
        this.$refs.studentSubmitDialog.open();
      },
      async onCompleteModalConfirm() {
        this.setLoading(true)
        await this.$store.dispatch('Application/markComplete');
        await this.$store.dispatch('Application/fetch', this.id)

        this.$store.dispatch('App/fetchUser').then(res => {
          this.setLoading(false)
          this.$nextTick(() => {
            this.$router.replace('/');
          })
        }).catch((error) => {
          this.setLoading(false)
          this.$nextTick(() => {
            this.$router.replace('/');
          })
        });
      },
      scrollTop: function () {
        window.scrollTo(0,0);
      },
      onStepChange(prevIndex, nextIndex) {
        this.currentStep = nextIndex + 1;
        this.scrollTop();
        this.setLoading(false)
        this.showErrorMessage = false;

        setTimeout(this.focusWizardContent, 1 * 1000)
      },
      onStepError(error) {
        if (error)
          this.setLoading(false)
      },
      onUsingScreenReaderChange() {
        this.setUsingScreenReader(!this.usingScreenReader);
      },
      stepUpdated() {
      },
      async validateStep(index) {
        let stepValid = false;
        this.setLoading(true)
        const step = this.steps[index]
        if (this.$refs[step.key] && this.$refs[step.key][0] && this.$refs[step.key][0].validateStep)
        {
          stepValid = await this.$refs[step.key][0].validateStep();

          if(!stepValid) {
            this.showErrorModal = true
          }
        } else {
          stepValid = true;
        }
        this.setLoading(false);

        return stepValid
      },
      onShowModalChange(showModal) {
        if (showModal) {
          setTimeout(() => {
            this.showComeBackModal && this.$refs.btnComeBack.focus();
            this.showErrorModal && this.$refs.btnCorrectError.focus();
          }, 1000);
        } else {
          setTimeout(() => {
            this.focusWizardContent();
          }, 1000);
        }
      },
      focusWizardContent() {
        let wizardElem = document.getElementsByClassName('wizard-tab-container');
        let focusableElements = [];
        if (wizardElem && wizardElem[this.currentStep - 1])
        {
          focusableElements = UIkit.Utils.findFocusables(document.getElementsByClassName('wizard-tab-container')[this.currentStep - 1]);
        }

        if (focusableElements.length > 0) {
          focusableElements[0].focus();
        } else {
          document.getElementsByClassName('wizard-btn wizard-footer-right uk-button')[0]?.focus();
        }
      },
    }
  }
</script>

<style  lang="scss">
  #screen-reader-checkbox {
    display: block;
    width: 1px;
    height: 0px;
    overflow: hidden;
  }
  .uk-progress-bar {
    background-color: #589fd2;
    padding-left: 0px;
    padding-right: 0px;
    & > span {
      padding-left: 10px;
    }
  }
  .agreement-container {
    padding: 20px;

    .agreement-title {
      font-size: 1.3em;
    }

    .uk-block-default {
      background-color: #efefef;
      padding: 20px 20px;
    }
  }

  @media only screen and (max-width: 600px) {
    .vue-form-wizard.md .wizard-icon-circle {
      width: 50px;
      height: 50px;
      font-size: 18px;

    }
    .stepTitle {
      font-size: 12px;
      padding: 2px;
    }

    .wizard-progress-with-circle {
      top: 30px !important;
    }

    .wizard-nav.wizard-nav-pills li {
      width: 25% !important;
    }
  }
</style>
